import { Button, Group, Text } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';

import styles from './CreatePatientModal.module.scss';

export interface Choice<T extends string> {
  value: T;
  label: string;
  /** Not shown; kept so callers can pass it without changes. */
  description?: string;
}

interface ChoiceCardsProps<T extends string> {
  choices: Choice<T>[];
  value: T | '';
  onChange: (value: T) => void;
  error?: string;
}

/**
 * A pair (or set) of regular app buttons acting as a single choice: the selected one is the
 * filled primary button, the others are default outline buttons. No radios.
 */
const ChoiceCards = <T extends string>({
  choices,
  value,
  onChange,
  error
}: ChoiceCardsProps<T>) => (
  <div>
    <Group gap={8} role="radiogroup">
      {choices.map((choice) => {
        const selected = choice.value === value;
        return (
          <Button
            key={choice.value}
            type="button"
            role="radio"
            aria-checked={selected}
            variant={selected ? 'filled' : 'default'}
            color="plum.8"
            radius="md"
            h={36}
            miw={140}
            leftSection={selected ? <IconCheck size={14} stroke={2.5} /> : null}
            onClick={() => onChange(choice.value)}>
            {choice.label}
          </Button>
        );
      })}
    </Group>
    {error && <Text className={styles.fieldError}>{error}</Text>}
  </div>
);

export default ChoiceCards;
